import getSites from "../api/sites/getSites";

import getServices from "../api/services/getServices";
import addService from "../api/services/addService";
import editService from "../api/services/editService";
import deleteService from "../api/services/deleteService";

import getCategories from "../api/categories/getCategories";
import addCategory from "../api/categories/addCategory";
import editCategory from "../api/categories/editCategory";
import deleteCategory from "../api/categories/deleteCategory";

const DataStore = {
    namespaced: true,
    state: {
        sites: [],
        categories: [],
        services: [],
    },
    getters: {

    },
    mutations: {
        setSites (state, sites) {
            state.sites = sites;
        },

        setCategories (state, categories) {
            state.categories = categories;
        },
        addCategory (state, category) {
            state.categories.push(category);
        },
        editCategory (state, updatedCategory) {
            state.categories
                .splice(
                    state.categories
                        .findIndex(
                            ({ _id }) => _id === updatedCategory._id
                        ),
                    1,
                    updatedCategory
                )
            state.categories
                .sort(
                    (a, b) => a.order - b.order
                );
        },
        deleteCategory (state, categoryId) {
            state.categories
                .splice(
                    state.categories
                        .findIndex(
                            ({ _id }) => _id === categoryId
                        ),
                    1
                );
        },

        setServices (state, services) {
            state.services = services;
        },
        addService (state, service) {
            state.services.push(service);
        },
        editService (state, updatedService) {
            state.services
                .splice(
                    state.services
                        .findIndex(
                            ({ _id }) => _id === updatedService._id
                        ),
                    1,
                    updatedService
                );
        },
        deleteService (state, serviceId) {
            state.services
                .splice(
                    state.services
                        .findIndex(
                            ({ _id }) => _id === serviceId
                        ),
                    1
                );
        },

        clear (
            state,
        ) {
            state.sites = [];
            state.categories = [];
            state.services = [];
        },
    },
    actions: {
        async loadSites (
            { commit }
        ) {
            let sites;
            try {
                sites = await getSites();
            } catch (e) {
                console.error(e);
                return;
            }
            commit(
                "setSites",
                sites
            );
            return sites;
        },

        async loadCategories (
            { commit }
        ) {
            let categories;
            try {
                categories = await getCategories();
            } catch (e) {
                console.error(e);
                return;
            }
            commit(
                "setCategories",
                categories
            );
            return categories;
        },
        async addCategory (
            { commit },
            newCategory,
        ) {
            let category;
            try {
                category = await addCategory(
                    newCategory
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "addCategory",
                category
            );
            return category;
        },
        async editCategory (
            { commit },
            updatedCategory
        ) {
            let category;
            try {
                category = await editCategory(
                    updatedCategory
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "editCategory",
                category
            );
            return category;
        },
        async deleteCategory (
            { commit },
            categoryId
        ) {
            try {
                await deleteCategory(
                    categoryId
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "deleteCategory",
                categoryId
            );
        },

        async loadServices (
            { commit }
        ) {
            let services;
            try {
                services = await getServices();
            } catch (e) {
                console.error(e);
                return;
            }
            commit(
                "setServices",
                services
            );
            return services;
        },
        async addService (
            { commit },
            newService,
        ) {
            let service;
            try {
                service = await addService(
                    newService
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "addService",
                service
            );
            return service;
        },
        async editService (
            { commit },
            updatedService
        ) {
            let service;
            try {
                service = await editService(
                    updatedService._id,
                    updatedService
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "editService",
                service
            );
            return service;
        },
        async deleteService (
            { commit },
            serviceId
        ) {
            try {
                await deleteService(
                    serviceId
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "deleteService",
                serviceId
            );
        },
    },
};

export default DataStore;
